<div class="text-center">
  <div *ngIf="field.signedOn">
    <div>
      <img [src]="field.signatureUrl" [alt]="field.fullName" />
    </div>
    <div>{{ field.fullName }}</div>
    <div>{{ field.signedOn | amDateFormat: 'lll' }}</div>
  </div>
</div>
